module.exports = __webpack_public_path__ + "static/media/bezier-curve.4ecfb5ef.svg";